import EventHubMixin from '@/mixins/EventHub.js'
import ScrollMixin from '@/mixins/Scroll.js'
import SizesMixin from '@/mixins/Sizes.js'

export default
{
    name: 'app-scroll-reveal',

    mixins:
    [
        EventHubMixin,
        ScrollMixin,
        SizesMixin
    ],

    components:
    {

    },

    props:
    {
        // the element will appear when we scroll until 20% of its height
        amplitude: { type: Number, default: 20 }
    },

    data()
    {
        return {
            hasAppeared: false
        }
    },

    created()
    {

    },

    mounted()
    {
        this.calculateBounds()
    },

    destroyed()
    {

    },

    methods:
    {
        onScroll()
        {
            this.checkVisibilityInBounds()
        },

        onResize()
        {
            this.calculateBounds()
            this.checkVisibilityInBounds()
        },

        calculateBounds()
        {
            const bounding = this.$el.getBoundingClientRect()

            this.bounds = {
                top: bounding.top + this.scroll.current,
                bottom: bounding.bottom + this.scroll.current,
                height: bounding.height,
                width: bounding.width
            }
        },

        checkVisibilityInBounds()
        {
            if(this.scroll.current + this.sizes.height > (this.bounds.top + this.bounds.height / 100 * this.amplitude) && !this.hasAppeared)
            {
                this.hasAppeared = true
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-scroll-reveal/script.js